import type { RBACGroup } from '../../types';

// An ACL is read-only in the cloud when it's mastered in on-prem AD: Graph rejects any
// membership edit ("on-premises mastered Directory Sync objects"). The reliable signal
// is the Graph `onPremisesSyncEnabled` property (true = synced up from on-prem AD).
//
// We keep the legacy `Onprem_` display-name prefix as a defensive fallback: those
// writeback groups surface in Entra with that prefix (e.g.
// Onprem_ACL_FS_ANZ_Projects_149969_Modify) and are always on-prem mastered, so they
// stay covered even on any query path that hasn't selected the property.
//
// NOTE: this is distinct from "AAD Group Writeback" *membership* (getACLWritebackMembership),
// which is the opposite direction — a cloud-mastered ACL configured to sync down to AD.
export const isOnPremGroup = (
  group: Pick<RBACGroup, 'displayName' | 'onPremisesSyncEnabled'> | undefined
): boolean =>
  !!group &&
  (group.onPremisesSyncEnabled === true || !!group.displayName?.toLowerCase().startsWith('onprem'));
